import StencilMode from '../gl/stencil_mode';
import DepthMode from '../gl/depth_mode';
import { terrainUniformValues, terrainDepthUniformValues, terrainCoordsUniformValues } from './program/terrain_program';
import CullFaceMode from '../gl/cull_face_mode';
import Texture from './texture';
import Color from '../style-spec/util/color';
import ColorMode from '../gl/color_mode';
const FBOs = {};
function drawTerrainCoords(painter, sourceCache) {
    const context = painter.context;
    const gl = context.gl;
    const colorMode = ColorMode.unblended;
    const depthMode = new DepthMode(gl.LEQUAL, DepthMode.ReadWrite, [0, 1]);
    const mesh = sourceCache.getTerrainMesh(context);
    const coords = sourceCache.getCoordsTexture(context);
    const tiles = sourceCache.getRenderableTiles(painter.transform);
    // draw tile-coords into framebuffer
    let program = painter.useProgram('terrainCoords');
    context.bindFramebuffer.set(sourceCache.getFramebuffer(painter, "coords").framebuffer);
    context.viewport.set([0, 0, painter.width / devicePixelRatio, painter.height / devicePixelRatio]);
    context.clear({ color: Color.transparent, depth: 1 });
    sourceCache._coordsIndex = [];
    for (const tile of tiles) {
        const terrain = sourceCache.getTerrain(tile.tileID);
        context.activeTexture.set(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, coords.texture);
        const posMatrix = painter.transform.calculatePosMatrix(tile.tileID.toUnwrapped());
        const uniformValues = terrainCoordsUniformValues(posMatrix, 255 - sourceCache._coordsIndex.length);
        program.draw(context, gl.TRIANGLES, depthMode, StencilMode.disabled, colorMode, CullFaceMode.backCCW, uniformValues, terrain, "terrain", mesh.vertexBuffer, mesh.indexBuffer, mesh.segments);
        sourceCache._coordsIndex.push(tile.tileID.key);
    }
    // draw depth into framebuffer
    program = painter.useProgram('terrainDepth');
    context.bindFramebuffer.set(sourceCache.getFramebuffer(painter, "depth").framebuffer);
    context.viewport.set([0, 0, painter.width / devicePixelRatio, painter.height / devicePixelRatio]);
    context.clear({ color: Color.transparent, depth: 1 });
    for (const tile of tiles) {
        const terrain = sourceCache.getTerrain(tile.tileID);
        const posMatrix = painter.transform.calculatePosMatrix(tile.tileID.toUnwrapped());
        const uniformValues = terrainDepthUniformValues(posMatrix);
        program.draw(context, gl.TRIANGLES, depthMode, StencilMode.disabled, colorMode, CullFaceMode.backCCW, uniformValues, terrain, "terrain", mesh.vertexBuffer, mesh.indexBuffer, mesh.segments);
    }
    context.bindFramebuffer.set(null);
    context.viewport.set([0, 0, painter.width, painter.height]);
}
function drawTerrain(painter, sourceCache, tile) {
    const context = painter.context;
    const gl = context.gl;
    const colorMode = painter.colorModeForRenderPass();
    const depthMode = new DepthMode(gl.LEQUAL, DepthMode.ReadWrite, painter.depthRangeFor3D);
    const program = painter.useProgram('terrain');
    const mesh = sourceCache.getTerrainMesh(context);
    const terrain = sourceCache.getTerrain(tile.tileID);
    context.bindFramebuffer.set(null);
    context.viewport.set([0, 0, painter.width, painter.height]);
    context.activeTexture.set(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, FBOs[tile.tileSize].colorAttachment.get());
    const posMatrix = painter.transform.calculatePosMatrix(tile.tileID.toUnwrapped());
    const uniformValues = terrainUniformValues(posMatrix);
    program.draw(context, gl.TRIANGLES, depthMode, StencilMode.disabled, colorMode, CullFaceMode.backCCW, uniformValues, terrain, "terrain", mesh.vertexBuffer, mesh.indexBuffer, mesh.segments);
}
function prepareTerrain(painter, sourceCache, tile, stack) {
    const context = painter.context;
    const size = tile.tileSize * sourceCache.qualityFactor; // may increase rendering-size for better quality
    if (!tile.textures[stack]) {
        tile.textures[stack] = painter.getTileTexture(size)
            || new Texture(context, { width: size, height: size, data: null }, context.gl.RGBA);
        tile.textures[stack].bind(context.gl.LINEAR, context.gl.CLAMP_TO_EDGE);
    }
    // reuse a framebuffer from the framebuffer-stack and attach active texture
    if (!FBOs[tile.tileSize]) {
        FBOs[tile.tileSize] = context.createFramebuffer(size, size, true);
        FBOs[tile.tileSize].depthAttachment.set(context.createRenderbuffer(context.gl.DEPTH_COMPONENT16, size, size));
    }
    FBOs[tile.tileSize].colorAttachment.set(tile.textures[stack].texture);
    context.bindFramebuffer.set(FBOs[tile.tileSize].framebuffer);
    context.viewport.set([0, 0, size, size]);
}
export { prepareTerrain, drawTerrain, drawTerrainCoords };
//# sourceMappingURL=draw_terrain.js.map